import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginRequest, LoginResponse } from "./auth.interfaces";
import { login } from "./auth.services";

const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (payload: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await login(payload);
      return response;
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export { loginUser };
